import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const modeApi = createApi({
	reducerPath: "amodeApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Mode"],

	endpoints: (builder) => ({
		getModes: builder.query<bt_mmode[], string>({
			query: (cid) => `mode/${cid}`,
			providesTags: ["Mode"],
		}),
		getMode: builder.query<bt_mmode, string>({
			query: (id) => `mode/byid/${id}`,
		}),
		insertMode: builder.mutation({
			query: (mode) => ({
				url: `/mode/`,
				method: "POST",
				body: mode,
			}),
			invalidatesTags: ["Mode"],
		}),
		updateMode: builder.mutation({
			query: (mode) => ({
				url: `/mode/`,
				method: "PUT",
				body: mode,
			}),
			invalidatesTags: ["Mode"],
		}),
		deleteMode: builder.mutation({
			query: (mode) => ({
				url: `/mode/${mode.us_id}`,
				method: "DELETE",
				body: mode,
			}),
			invalidatesTags: ["Mode"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetModesQuery,
	useGetModeQuery,
	useInsertModeMutation,
	useUpdateModeMutation,
	useDeleteModeMutation,
} = modeApi;
